/* global Glider */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
window.addEventListener('load',function(){

    window._ = new Glider(document.querySelector('.glider'), {
        slidesToShow: 1,
        slidesToScroll: 1,
        rewind: true,
        arrows: {
            prev: '.glider-prev',
            next: '.glider-next'
        },
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                }
            },
        ]
    });
});

document.addEventListener('DOMContentLoaded', () => {
    jQuery(($) => {
        $('.item-size > li').on('click', (event) => {
            const $target = $(event.target).closest('li'); // Ensure we target the <li> even if a child is clicked
            const variationId = $target.data('variation-id');
            const variationPrice = $target.data('variation-price');
            const currencySymbol = $target.data('currency-symbol');

            $target.siblings().removeClass('active');
            $target.addClass('active');

            if ( typeof variationId !== 'undefined' && typeof variationPrice !== 'undefined' ) {
                // Traverse up to find the common parent and then find the corresponding "Add to Cart" button
                const $button = $target.closest('.item-block').find('.item-add-to-cart');

                // Update the 'data-product-id' of the button to the selected variation ID
                $button.attr('data-product-id', variationId);

                // Navigate up to the common ancestor and find the .item-price container
                const $itemInfo = $target.closest('.item-block').find('.item-price span');

                // Update the price display
                if (typeof variationPrice !== 'undefined') {
                    $itemInfo.html(variationPrice + ' ' + currencySymbol);
                }
            }
        });
    });
});
